module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-portfolio"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-content portfolio"
  }, [_vm._t("default")], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbo-wrapper portfolio"
  }, [_c('div', {
    staticClass: "jumbo-main"
  }, [_c('div', {
    staticClass: "jumbo-content"
  }, [_c('p', {
    staticClass: "t15"
  }, [_vm._v("PORTFOLIO")]), _vm._v(" "), _c('h2', {
    staticClass: "t42"
  }, [_vm._v("\n                    32+ YEARS OF PROJECTS\n                    "), _c('br'), _vm._v("\n                    ACROSS THE COUNTRY\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "t20"
  }, [_vm._v("Start one in your community today!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1db45a9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Portfolio.vue
// module id = YL3Q
// module chunks = 1